import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import MafiaAcademy from './MafiaAcademy.jsx'

// Переключатель backend хранилища.
const mode = import.meta.env.VITE_STORAGE_MODE || 'mysql';

let shimLoader;
if (mode === 'supabase') {
  shimLoader = import('./storage-shim-supabase.js');
} else if (mode === 'mysql') {
  shimLoader = import('./storage-shim-mysql.js');
} else {
  shimLoader = import('./storage-shim.js');
}

// ─── Error Boundary ─────────────────────────────────────────────────
// Если в любом компоненте упадёт runtime-ошибка — вместо чёрного экрана
// пользователь увидит понятное сообщение с возможностью вернуться на главную.
// На прод-сервере дополнительно лог отправляется в /api/client-error.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    // Лог в консоль для разработчика
    console.error('[ErrorBoundary]', error, errorInfo);
    // Попытка отправить лог на сервер (best-effort, не блокирует)
    try {
      const apiUrl = import.meta.env.VITE_API_URL || '/api';
      fetch(`${apiUrl}/client-error`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message: String(error?.message || error),
          stack: String(error?.stack || ''),
          componentStack: String(errorInfo?.componentStack || ''),
          userAgent: navigator.userAgent,
          url: window.location.href,
          at: new Date().toISOString(),
        }),
      }).catch(() => {});
    } catch {}
  }
  reset = () => {
    this.setState({ hasError: false, error: null, errorInfo: null });
  };
  render() {
    if (this.state.hasError) {
      const isDev = import.meta.env.DEV;
      return (
        <div style={{
          minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: '#0A0B0D', color: '#fff', fontFamily: 'sans-serif',
          padding: '20px', textAlign: 'center'
        }}>
          <div style={{ maxWidth: 600, width: '100%' }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>⚠</div>
            <div style={{ fontSize: 24, color: '#E83A2C', marginBottom: 12, fontWeight: 600 }}>
              Что-то пошло не так
            </div>
            <div style={{ fontSize: 14, color: '#9B9BA4', marginBottom: 24, lineHeight: 1.5 }}>
              Произошла ошибка в работе приложения. Мы уже знаем о&nbsp;ней.<br/>
              Попробуйте обновить страницу или вернуться назад.
            </div>
            {isDev && this.state.error && (
              <div style={{
                background: '#15171B', border: '1px solid #2A2E36', borderRadius: 8,
                padding: 16, marginBottom: 16, textAlign: 'left',
                fontFamily: 'monospace', fontSize: 12, color: '#FF8B94',
                maxHeight: 200, overflow: 'auto'
              }}>
                <div style={{ marginBottom: 8, fontWeight: 600 }}>{this.state.error.message}</div>
                <div style={{ color: '#5F5F68', fontSize: 10, whiteSpace: 'pre-wrap' }}>
                  {this.state.error.stack?.split('\n').slice(0, 5).join('\n')}
                </div>
              </div>
            )}
            <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
              <button onClick={() => window.location.reload()} style={{
                background: '#E83A2C', color: '#fff', border: 'none', padding: '12px 24px',
                borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer',
                fontFamily: 'monospace', letterSpacing: '0.05em'
              }}>↻ ОБНОВИТЬ СТРАНИЦУ</button>
              <button onClick={this.reset} style={{
                background: 'transparent', color: '#fff', border: '1px solid #2A2E36',
                padding: '12px 24px', borderRadius: 8, fontSize: 14, fontWeight: 600,
                cursor: 'pointer', fontFamily: 'monospace', letterSpacing: '0.05em'
              }}>← НАЗАД</button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

shimLoader
  .then(() => {
    ReactDOM.createRoot(document.getElementById('root')).render(
      <ErrorBoundary>
        <MafiaAcademy />
      </ErrorBoundary>
    )
  })
  .catch((err) => {
    console.error('Failed to load storage shim:', err);
    document.getElementById('root').innerHTML = `
      <div style="min-height:100vh;display:flex;align-items:center;justify-content:center;background:#0A0B0D;color:#fff;font-family:sans-serif;padding:20px;text-align:center;">
        <div>
          <div style="font-size:24px;color:#E83A2C;margin-bottom:12px;">⚠ Ошибка инициализации</div>
          <div style="font-size:14px;color:#999;margin-bottom:8px;">${err.message}</div>
          <div style="font-size:12px;color:#666;">Проверьте файл .env и пересоберите приложение</div>
        </div>
      </div>
    `;
  });
